// frontend/src/components/Common/NotificationBell/NotificationPanel.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../context/TranslationContext';
import { FiCheckCircle, FiRefreshCw, FiBell } from 'react-icons/fi';
import NotificationItem from './NotificationItem';
import './NotificationBell.css';

const NotificationPanel = ({ 
  notifications = [],
  loading, 
  onClose, 
  onMarkAsRead, 
  onMarkAllAsRead,
  onDelete,
  onRefresh 
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const unreadNotifications = notifications.filter(n => n && !n.is_read);

  const handleNotificationClick = (notification) => {
    if (!notification) return;
    
    // Mark as read
    if (!notification.is_read) {
      onMarkAsRead(notification.notification_id);
    }

    // Navigate if has URL
    if (notification.entity_url) {
      navigate(notification.entity_url);
      onClose();
    }
  };

  return (
    <div className="notification-panel">
      {/* Header */}
      <div className="notification-panel-header">
        <h3>{t('notifications.title', 'Notifications')}</h3>
        <div className="notification-panel-actions">
          {unreadNotifications.length > 0 && (
            <button
              onClick={onMarkAllAsRead}
              className="notif-btn-mark-all-read"
              title={t('notifications.mark_all_read', 'Mark all as read')}
            >
              <FiCheckCircle 
                size={16}
                style={{ color: 'white' }}  // ✅ Force white icon
              />
            </button>
          )}
          <button
            onClick={onRefresh}
            className="notif-btn-refresh"
            title={t('notifications.refresh', 'Refresh')}
            disabled={loading}
          >
            <FiRefreshCw 
              size={16} 
              className={loading ? 'spinning' : ''}
              style={{ color: 'white' }}  // ✅ Force white icon on green background
            />
          </button>
        </div>
      </div>

      {/* Notifications List */}
      <div className="notification-panel-list">
        {loading && notifications.length === 0 ? (
          <div className="notification-loading">
            {t('loading', 'Loading...')}
          </div>
        ) : notifications.length === 0 ? (
          <div className="notification-empty">
            <FiBell size={48} />
            <p>{t('notifications.no_notifications', 'No notifications')}</p>
          </div>
        ) : (
          notifications
            .filter(n => n && n.notification_id)
            .map(notification => (
              <NotificationItem
                key={notification.notification_id}
                notification={notification}
                onClick={() => handleNotificationClick(notification)}
                onDelete={onDelete}
              />
            ))
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;